export const APP_COMMIT = "ad20f574a51c68553b23cd52fba0d4b93bc35ecf";
export const DESIRED_IAC_VERSIONS: Readonly<Record<string, string>> = {"avd":"c3aef8b27a54","base":"c91550fcb440","swa":"9eeca0565bf6"};
